import { Button, ButtonProps } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";

type FormSubmitProps = ButtonProps;

export default function FormCancel({
  variant = "ghost",
  children = "Cancel",
  onClick,
  ...props
}: FormSubmitProps) {
  const {
    formState: { isSubmitting },
    reset,
  } = useFormContext();

  return (
    <Button
      isDisabled={props.isDisabled || isSubmitting}
      type="button"
      variant={variant}
      onClick={(e) => {
        reset();
        onClick?.(e);
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
